const FEATURE = [
  (s, line, link) => `#ad ${s}, this one's for you today: "${line}" Read the rest of your horoscope here: ${link}`,
  (s, line, link) => `#ad Calling all ${s} ✨ "${line}" Your full horoscope for today: ${link}`,
  (s, line, link) => `#ad ${s}, read this before lunch: "${line}" More here: ${link}`,
  (s, line, link) => `#ad Today's ${s} energy in one line: "${line}" Tap for the full reading: ${link}`,
  (s, line, link) => `#ad ${s} rising, sun or moon? Today's message: "${line}" See yours: ${link}`,
  (s, line, link) => `#ad A little note for ${s} today 🌙 "${line}" The rest is on my page: ${link}`,
];
const GENERAL = [
  (link) => `#ad Your daily horoscope is up ✨ Read yours, written from where the planets really are today: ${link}`,
  (link) => `#ad Which sign are you? Today's horoscope for all 12 signs is free on my page: ${link}`,
  (link) => `#ad Want a reading for your exact birth chart, not just your sign? Natal, Synastry and Solar Return readings here: ${link}`,
  (link) => `#ad Tag a friend whose sign needs to hear today's horoscope 👇 ${link}`,
  (link) => `#ad Morning ritual: coffee, then your horoscope. Today's is ready: ${link}`,
  (link) => `#ad Curious how you and your partner match? Compatibility and birth chart readings: ${link}`,
  (link) => `#ad The planets moved overnight. Here's what that means for your sign today: ${link}`,
  (link) => `#ad Save this and check your sign every morning: ${link}`,
];
const COMMISSION = "\n\nI may earn a commission if you buy through my Astra link.";

const firstSentence = (t = "") => (t.trim().match(/^.*?[.!?](\s|$)/) || [t])[0].trim();
const hash = (s) => [...s].reduce((h, c) => (h * 31 + c.charCodeAt(0)) >>> 0, 7);

// Same set all day for a creator; `round` swaps in a different set.
export function dailyCaptions(signs, link, seedKey, round = 0) {
  const day = new Date().toISOString().slice(0, 10);
  const seed = hash(`${day}|${seedKey}`) + round * 3;
  const out = [];
  if (signs.length) {
    for (let i = 0; i < 2; i++) {
      const s = signs[(seed + i * 5 + round * 2) % signs.length];
      out.push(FEATURE[(seed + i + round) % FEATURE.length](s.sign, firstSentence(s.overall), link));
    }
  }
  out.push(GENERAL[(seed + round) % GENERAL.length](link) + COMMISSION);
  out.push(GENERAL[(seed + round + 3) % GENERAL.length](link));
  return out;
}
